import { Collapse } from "@mui/material";
import { InputCheck } from "controls";
import React, { useEffect } from "react";

const CurrencyAccess = ({ values, setValues }) => {
  useEffect(() => {
    if (!values.id) {
      values.currencyAccess
        ? setValues((j) => ({
            ...j,
            currency: {
              create: true,
              edit: true,
              delete: true,
            },
          }))
        : setValues((j) => ({
            ...j,
            currency: {
              create: false,
              edit: false,
              delete: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.currencyAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setValues((j) => ({
      ...j,
      currency: { ...j.currency, [name]: checked },
    }));
  };

  return (
    <Collapse in={values.currencyAccess || false}>
      <div className="ml-[3px] grid gap-1 mt-[2px] mb-[10px] !uppercase tracking-wider !pl-[10px] border-l-4  border-rounded">
        <InputCheck
          label="Create"
          checked={values.currency?.create || false}
          name={"create"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Edit"
          checked={values.currency?.edit || false}
          name={"edit"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Delete"
          checked={values.currency?.delete || false}
          name={"delete"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default CurrencyAccess;
